import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import hazardousGoodsImg from "../../../../assets/imgs/services/nationals/hazardous-goods.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function HazardousGoods() {
  const [tHazardousGoods] = useTranslation("hazardousGoodsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idHazardousGoods = "d5593ad8-15cd-4168-90d9-27ed9b86cfb9";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[11]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[11]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idHazardousGoods}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Documentación"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(response.data.textWeb.text_us["04-Check-in"].content);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("mercancíaPeligrosa.title")}</title>
        <meta
          name="description"
          content={tSMetaData("mercancíaPeligrosa.description")}
        />
      </Helmet>
      <ImageHeader
        section={tHazardousGoods("header.section")}
        title={tHazardousGoods("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tHazardousGoods("description.content"))
        }
        contactSales={tHazardousGoods("header.contact-sales")}
        contactProductID="btnContactHazardous"
        imgBackground={hazardousGoodsImg}
      />
      <Accordion
        title={tHazardousGoods("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tHazardousGoods("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHazardousGoods("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tHazardousGoods("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tHazardousGoods("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tHazardousGoods("accordion-3.content"))
        }
      />
    </>
  );
}

export default HazardousGoods;
